import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path:'/index',
			name:'index',
			meta:{
				name:''
			},
			alias:'/',
			component:resolve=>require(['@/download/views/home/index.vue'],resolve)
		},
	]
})



// WEBPACK FOOTER //
// ./src/download/router/index.js